import { twdClass } from "../../../constants/tailwind.constants";
import { useState, useEffect, useRef} from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  SELECT_ELEMENT
} from "../../../constants/action.constants";

export const RenderArea = ({path='', children}) => {
  const {
    selectElement,
  } = useSelector((state) => state.studioDetails);

  const ref = useRef(null)
  const [isSelected, setSelected] = useState(false); 
  const dispatch = useDispatch(); 

  useEffect(()=>{
    if(path==selectElement.path) {     
      const rect = ref.current.getBoundingClientRect();
      //const ofw=elementRef.current.offsetWidth
      //const off= {top:rect.top-trigParent.top, left:rect.left-trigParent.left, width:rect.width, height:rect.height}
      //updateTriggerable({path, offset:off})
      dispatch({ type: SELECT_ELEMENT, data: {top:rect.top} })
      //console.log("RenderElements rect", element.updateTo, rect); // Should now be non-zero
      setSelected(true)
      setTimeout(()=>{
        setSelected(false)
      }, 300)
      //console.log("selected Element", rect, selectElement)
      console.log("selected Element", path, rect.top, selectElement.path)
    }    
  }, [selectElement.path])
  
  return(
    <div ref={ref}  className={twdClass(`transition-all duration-150 ease-in-out ${isSelected ? 'border-2 border-blue-500 rounded-lg':''}`)}>
      {children}</div>
  )
}
